import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSellerList, onlineShopAreaFind, onlineShopAreaCreate, onlineShopAreaUpdate, getGoodsCategoryList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { removeImgUrlSuffix } from '@/utils/stringFun';
import { mapGetters } from 'vuex';
import UploadImage from '@/components/upload/image';
import GoodsSelectComponent from '@/view/bianlidianManage/onlineshop/goodsSelectComponent';
import Draggable from 'vuedraggable';

var _this;

export default {
  name: 'OnlineShopAddArea',
  components: {
    UploadImage: UploadImage,
    GoodsSelectComponent: GoodsSelectComponent,
    Draggable: Draggable
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerName: function getSellerName(id) {
      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId == id) {
          return _this.sellerOptions[i].sellerName;
        }
      }

      return '';
    },
    getActivityTypes: function getActivityTypes(activityTypes) {
      var activityTypesArr = activityTypes.split(',');
      var arr = [];

      if (activityTypesArr.includes('1')) {
        arr.push('券');
      }

      if (activityTypesArr.includes('2')) {
        arr.push('积分');
      }

      return arr.length === 0 ? '' : '返' + arr.join('+');
    },
    getCategoryName: function getCategoryName(categoryNo) {
      for (var i = 0; i < _this.categoryOptions.length; i++) {
        if (_this.categoryOptions[i].categoryNo == categoryNo) {
          return _this.categoryOptions[i].name;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      goodsTableData: [],
      formData: {},
      addAreaImgUrl: '',
      sellerOptions: [],
      sellerCheckAll: false,
      categoryOptions: [],
      currentAreaItem: null,
      goodsComponentFormData: {
        dialogVisible: false,
        sellerId: 0,
        selection: [] // 回显，如果有数据，组件默认勾选

      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('AddArea activated');

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var sellerOptions, res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('AddArea created');

              if (_this.$route.params) {
                _this.searchInfo = _this.$route.params;
              }

              _this2.formData = !_this.searchInfo.showAreaNo && localStorage.getItem('onlineShopAddArea') ? JSON.parse(localStorage.getItem('onlineShopAddArea')) : _this2.initData();
              _context2.next = 5;
              return getSellerList({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 5:
              sellerOptions = _context2.sent;
              _this2.sellerOptions = sellerOptions.data.list;
              _this2.formData.sellerId = _this2.sellerOptions[0].sellerId;
              _context2.next = 10;
              return getGoodsCategoryList({
                'parentNo': 0
              });

            case 10:
              res = _context2.sent;
              _this2.categoryOptions = res.data.list;

              if (_this.searchInfo.showAreaNo) {
                _this2.handleFindDetail(_this.searchInfo.showAreaNo);
              }

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    initData: function initData() {
      return {
        sellerId: 0,
        showAreaName: '',
        backgroudColor: '',
        showAreaImgUrl: [],
        showAreaStatus: 5,
        isRecommend: 2,
        isShowRecommend: 1,
        weight: 0,
        showAreaDetailList: [this.initAreaSingle()]
      };
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    onChangeIsRecommend: function onChangeIsRecommend() {
      this.formData.showAreaDetailList.length = 1;
      this.$forceUpdate();
    },
    // 上传成功
    areaImgUploadSuccess: function areaImgUploadSuccess(res) {
      this.formData.showAreaImgUrl[0] = res.data.file.url;
      this.$forceUpdate();
    },
    // 删除图
    onDeleteAreaImg: function onDeleteAreaImg(index) {
      this.formData.showAreaImgUrl.splice(index, 1);
    },
    // 添加图片链接
    onAddImgUrl: function onAddImgUrl(target) {
      if (target === 'addAreaImgUrl' && this.addAreaImgUrl.trim() != '') {
        this.formData.showAreaImgUrl[0] = removeImgUrlSuffix(this.addAreaImgUrl.trim());
      }

      this.addAreaImgUrl = '';
      this.$forceUpdate();
    },
    // 添加区域
    onAddArea: function onAddArea() {
      if (this.formData.isRecommend === 1) {
        this.formData.showAreaDetailList = [this.initAreaSingle()];
      } else {
        this.formData.showAreaDetailList.push(this.initAreaSingle());
      }
    },
    // 删除区域
    onDelArea: function onDelArea(areaIndex) {
      this.formData.showAreaDetailList.splice(areaIndex, 1);
    },
    initAreaSingle: function initAreaSingle() {
      return {
        'showAreaDetailName': '',
        'showAreaDetailNameSub': '',
        'showAreaDetailNum': 1,
        'showAreaDetailGoodsList': []
      };
    },
    // 添加商品
    onAddGoods: function onAddGoods(areaItem) {
      this.currentAreaItem = areaItem;
      this.goodsComponentFormData.dialogVisible = true;
      this.goodsComponentFormData.sellerId = this.formData.sellerId;
    },
    // 删除商品
    onDelGoods: function onDelGoods(areaItem, row) {
      areaItem.showAreaDetailGoodsList = areaItem.showAreaDetailGoodsList.filter(function (item) {
        return item.goodsDetailNo != row.goodsDetailNo;
      });
    },
    // 修改排序
    onGoodsWeightChange: function onGoodsWeightChange(areaItem) {
      areaItem.showAreaDetailGoodsList.sort(function (a, b) {
        return a.weight - b.weight;
      });
    },
    // 选择商品-确定
    goodsSelDialogOk: function goodsSelDialogOk(res) {
      var _this3 = this;

      this.goodsComponentFormData.dialogVisible = false;

      if (res && res.length > 0) {
        var maxWeight = 0;
        this.currentAreaItem.showAreaDetailGoodsList.forEach(function (item) {
          if (item.weight > maxWeight) {
            maxWeight = item.weight;
          }
        });
        res.forEach(function (item, index) {
          if (!_this3.currentAreaItem.showAreaDetailGoodsList.some(function (item2) {
            return item2.goodsDetailNo === item.goodsDetailNo;
          })) {
            maxWeight = maxWeight + 100;
            item.weight = maxWeight;

            _this3.currentAreaItem.showAreaDetailGoodsList.push(JSON.parse(JSON.stringify(item)));
          }
        });
      }
    },
    // 选择商品-关闭
    goodsSelDialogClose: function goodsSelDialogClose() {
      this.goodsComponentFormData.dialogVisible = false;
    },
    onCache: function onCache() {
      if (!this.searchInfo.showAreaNo) {
        localStorage.setItem('onlineShopAddArea', JSON.stringify(this.formData));
      }
    },
    onClear: function onClear() {
      this.formData = this.initData();
      this.formData.sellerId = this.sellerOptions[0].sellerId;
      localStorage.removeItem('onlineShopAddArea');
    },
    // 详情查询
    handleFindDetail: function handleFindDetail(showAreaNo) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var detailRes;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return onlineShopAreaFind({
                  'showAreaNo': showAreaNo
                });

              case 2:
                detailRes = _context3.sent;
                _this4.formData.sellerId = detailRes.data.sellerId;
                _this4.formData.showAreaName = detailRes.data.showAreaName;
                _this4.formData.showAreaImgUrl = detailRes.data.showAreaImgUrl ? [detailRes.data.showAreaImgUrl] : '';
                _this4.formData.showAreaStatus = detailRes.data.showAreaStatus;
                _this4.formData.backgroudColor = detailRes.data.backgroudColor;
                _this4.formData.weight = detailRes.data.weight;
                _this4.formData.categoryNo = detailRes.data.categoryNo;
                _this4.formData.isRecommend = detailRes.data.isRecommend;
                _this4.formData.isShowRecommend = detailRes.data.isShowRecommend;
                _this4.formData.showAreaDetailList = detailRes.data.showAreaDetailList || [];

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onSave: function onSave() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var showAreaDetailList, param, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!_this5.formData.showAreaName && _this5.formData.isRecommend == 2)) {
                  _context4.next = 3;
                  break;
                }

                _this5.$message({
                  type: 'warning',
                  message: '专区标题不能为空！'
                });

                return _context4.abrupt("return");

              case 3:
                if (_this5.formData.isRecommend == 1) {
                  _this5.formData.showAreaName = '为您推荐专区';
                  _this5.formData.isShowRecommend = 1;
                  _this5.formData.backgroudColor = '';
                  _this5.formData.showAreaImgUrl = [];
                  _this5.formData.categoryNo = 0;

                  _this5.formData.showAreaDetailList.forEach(function (item) {
                    item.showAreaDetailName = '';
                    item.showAreaDetailNameSub = '';
                    item.showAreaDetailNum = 2;
                  });
                }

                showAreaDetailList = _this5.formData.showAreaDetailList.filter(function (item) {
                  return item.showAreaDetailGoodsList && item.showAreaDetailGoodsList.length > 0;
                });
                param = {
                  'sellerId': _this5.formData.sellerId,
                  'categoryNo': _this5.formData.categoryNo,
                  'categoryName': _this5.$options.filters.getCategoryName(_this5.formData.categoryNo),
                  'showAreaName': _this5.formData.showAreaName,
                  'showAreaImgUrl': _this5.formData.showAreaImgUrl[0] || '',
                  'isShowRecommend': _this5.formData.isShowRecommend,
                  'isRecommend': _this5.formData.isRecommend,
                  'backgroudColor': _this5.formData.backgroudColor || '',
                  'showAreaStatus': _this5.formData.showAreaStatus,
                  'weight': _this5.formData.weight,
                  'startTime': '2022-12-30 00:00:00',
                  'endTime': '2099-01-01 00:00:00',
                  'showAreaDetailList': showAreaDetailList.map(function (item) {
                    return {
                      'showAreaDetailName': item.showAreaDetailName,
                      'showAreaDetailNameSub': item.showAreaDetailNameSub,
                      'showAreaDetailNum': item.showAreaDetailNum,
                      'weight': item.weight,
                      'showAreaDetailGoodsList': item.showAreaDetailGoodsList.map(function (item2) {
                        return {
                          'goodsDetailNo': item2.goodsDetailNo,
                          'spuNo': item2.spuNo,
                          'weight': item2.weight,
                          'imgUrl': item2.imgUrl
                        };
                      })
                    };
                  })
                };
                res = {};

                if (_this5.searchInfo.showAreaNo) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 10;
                return onlineShopAreaCreate(param);

              case 10:
                res = _context4.sent;
                _context4.next = 17;
                break;

              case 13:
                param.showAreaNo = _this5.searchInfo.showAreaNo;
                _context4.next = 16;
                return onlineShopAreaUpdate(param);

              case 16:
                res = _context4.sent;

              case 17:
                if (res.code == 0) {
                  _this5.$message({
                    type: 'success',
                    message: '操作成功！'
                  });

                  setTimeout(function () {
                    _this5.onClear();

                    _this5.goBack();
                  }, 300);
                }

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};